'use client';

import { CuteSpinner } from '@/components/common/CuteSpinner';
import { cn } from '@/lib/utils';

interface ChatSyncIndicatorProperties {
  className?: string;
}

export function ChatSyncIndicator({ className }: ChatSyncIndicatorProperties) {
  return (
    <div
      className={cn(
        'inline-flex h-11 w-11 items-center justify-center rounded-full border border-border/60 bg-card/70 shadow-[018px_48px_-38px_var(--mix-hslprimary-58pct-transparent)] backdrop-blur-lg',
        className
      )}
    >
      <span className="sr-only">Syncing fresh context</span>
      <CuteSpinner size={20} className="text-primary border-primary/30 border-t-primary" aria-hidden="true" />
    </div>
  );
}
